<template>
  <div class="pcoded-inner-content">
    <div class="main-body">
      <div>
        <div>
          <div>
            <div>
              <div class="card-wise-wise">
                <div class="card-header-wise">
                  <div>
                    <h4>Crie Sua Mensagem</h4>
                    <span>Preencha os campos abaixo:</span>
                  </div>
                </div>
                <div>
                  <div class="form-group">
                    <label>Título</label>
                    <input
                      v-model="titleMsgElement"
                      @input="updateTitle"
                      type="text"
                      class="form-control"
                      placeholder="Apenas para identificar a mensagem no sistema."
                    />
                  </div>
                  <div class="form-group">
                    <label>Canal</label>
                    <input
                      v-model="channelElement"
                      @input="updateChannel"
                      :placeholder="placeholderUuid"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group">
                    <label>Categoria</label>
                    <select
                      v-model="category"
                      class="form-control"
                      @change="updateCategory"
                    >
                      <option disabled value="">Selecione uma Opção</option>
                      <option
                        v-for="item in categories"
                        :key="item.name"
                        :value="item"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>

                  <div
                    class="form-group"
                    v-if="
                      // category && category.name.toLowerCase() !== 'whatsnews'
                      false
                    "
                  >
                    <label>Status</label>
                    <select
                      v-model="statusSelected"
                      class="form-control"
                      @change="updateStatus"
                    >
                      <option disabled value="">Selecione uma Opção</option>
                      <option
                        v-for="item in category.status"
                        :key="item.name"
                        :value="item.name"
                      >
                        {{ item.description || item.name }} ({{ item.name }})
                      </option>
                    </select>
                  </div>

                  <div class="form-group" v-if="statusSelected">
                    <label>Situação</label>
                    <select
                      v-model="situationSelected"
                      class="form-control"
                      @change="updateSituation"
                    >
                      <option disabled value="">Selecione uma Opção</option>
                      <option
                        v-for="item in situationData"
                        :key="item.name"
                        :value="item"
                      >
                        {{ item.description || item.name }} ({{ item.name }})
                      </option>
                    </select>
                  </div>

                  <div class="form-group" v-if="false">
                    <div
                      class="form-input-control"
                      v-for="(notification,
                      idx) in situationSelected.notification"
                      :key="idx"
                    >
                      <label>{{ notification.name }}</label>
                      <input
                        v-model="notification.value"
                        :placeholder="notification.placeholder"
                        @input="updateNotification(idx)"
                        type="number"
                      />
                    </div>
                  </div>
                  <!-- DINAMIC -->
                  <div
                    class="form-group"
                    v-if="
                      category && category.name.toLowerCase() !== 'whatsnews'
                    "
                  >
                    <label>Status</label>
                    <select
                      v-model="statusDinamicSelected"
                      class="form-control"
                      @change="updateDinamicStatus"
                    >
                      <option disabled value="">Selecione uma Opção</option>
                      <option
                        v-for="item in category.status"
                        :key="item.name"
                        :value="item.name"
                      >
                        {{ item.description || item.name }} ({{ item.name }})
                      </option>
                    </select>
                  </div>
                  <div class="shipping-time" v-if="statusDinamicSelected">
                    <div class="form-group">
                      <label>Situação</label>
                      <select
                        v-model="situationDinamicSelected"
                        class="form-control"
                        @change="updateDinamicSituation"
                      >
                        <option disabled value="">Selecione uma Opção</option>
                        <option
                          v-for="item in situationDinamicData"
                          :key="item.name"
                          :value="item"
                        >
                          {{ item.description || item.name }} ({{ item.name }})
                        </option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Hora de Envio</label>
                      <input
                        v-model="shippingSchedule"
                        type="time"
                        class="form-control-time"
                        @change="updateShippingSchedule"
                      />
                    </div>
                    <div class="form-group">
                      <label>Enviar somente em dias úteis</label>
                      <woot-switch
                        size="large"
                        class="auto-offline--switch"
                        :value="weekendShippingLock"
                        @input="updateWeekendShippingLock"
                      />
                    </div>
                  </div>
                  <div v-if="situationDinamicSelected" class="form-group">
                    <div
                      v-for="(notificationDinamic,
                      idxx) in situationDinamicSelected.notification"
                      :key="idxx"
                      class="form-input-control"
                    >
                      <label
                        >{{ notificationDinamic.name }}
                        {{ notificationDinamic.position }}
                      </label>
                      <input
                        v-model.number="notificationDinamic.value"
                        :placeholder="notificationDinamic.placeholder"
                        @input="updateDinamicNotification(idxx)"
                        type="number"
                        min="0"
                      />
                    </div>
                    <div>
                      <button
                        @click="
                          removeDinamicNotification(situationDinamicSelected)
                        "
                        :class="
                          situationDinamicSelected.notification.length === 1
                            ? 'disabled'
                            : ''
                        "
                        :disabled="
                          situationDinamicSelected.notification.length === 1
                        "
                        class="btn btn-danger"
                      >
                        Excluir
                      </button>
                      <button
                        @click="
                          addDinamicNotification(situationDinamicSelected)
                        "
                        class="btn btn-info"
                      >
                        Repetir
                      </button>
                    </div>
                  </div>

                  <div
                    class="form-group"
                    v-if="
                      category && category.name.toLowerCase() === 'whatsnews'
                    "
                  >
                    <label>ID da Lista</label>
                    <select
                      v-model="selectedList"
                      class="form-control"
                      @change="checkList"
                    >
                      <option
                        v-for="item in lists"
                        :key="item.list_id"
                        :value="item.list_id"
                      >
                        {{ item.nome }} | {{ item.list_id }}
                      </option>
                    </select>
                  </div>

                  <div
                    v-if="
                      category && category.name.toLowerCase() === 'whatsnews'
                    "
                    class="form-group"
                  >
                    <label>Data de Envio</label>
                    <input v-model="date" type="date" class="form-control" />
                    <input
                      v-model="time"
                      type="time"
                      class="form-control"
                      @change="getDate"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      titleMsgElement: '',
      category: '',
      situation: '',
      situationData: [
        {
          name: 'Lembrete',
          notification: [
            {
              name: 'notificação 1',
              placeholder: 'Dias antes da data de vencimento',
              value: null,
            },
            {
              name: 'notificação 2',
              placeholder: 'Dias antes da data de vencimento',
              value: null,
            },
          ],
        },
        {
          name: 'Cobrança',
          notification: [
            {
              name: 'notificação 3',
              placeholder: 'Dias após da data de vencimento',
              value: null,
            },
            {
              name: 'notificação 4',
              placeholder: 'Dias após da data de vencimento',
              value: null,
            },
          ],
        },
      ],
      situationDinamicData: [
        {
          name: 'Lembrete',
          notification: [
            {
              name: 'notificação',
              position: 1,
              key: `notification_1`,
              placeholder: 'Dias antes da data de vencimento',
              value: null,
            },
          ],
        },
        {
          name: 'Cobrança',
          notification: [
            {
              name: 'notificação',
              position: 101,
              key: `notification_101`,
              placeholder: 'Dias após da data de vencimento',
              value: null,
            },
          ],
        },
      ],
      channelElement: '',
      statusSelected: '',
      statusDinamicSelected: '',
      situationSelected: '',
      situationDinamicSelected: '',
      useTemplateOption: '0',
      selectedTemplateOption: null,
      selectedList: '',
      date: '',
      time: '',
      shippingSchedule: '',
      weekendShippingLock: false,
    };
  },

  methods: {
    updateTitle() {
      this.$emit('updateFormData', { title: this.titleMsgElement });
    },
    updateChannel() {
      this.$emit('updateFormData', { channel: this.channelElement });
    },
    updateCategory() {
      this.$emit('updateFormData', { category: this.category.name });
    },
    updateStatus() {
      this.$emit('updateFormData', { status: this.statusSelected });
    },
    updateSituation() {
      this.$emit('updateFormData', { situation: this.situationSelected.name });
    },
    updateDinamicStatus() {
      this.$emit('updateFormData', { status: this.statusDinamicSelected });
    },
    updateDinamicSituation() {
      this.$emit('updateFormData', {
        situation: this.situationDinamicSelected.name,
      });
    },
    updateNotification(index) {
      this.$emit('updateFormData', {
        [`notification_${index + 1}`]: this.situationSelected.notification[
          index
        ].value,
      });
    },
    updateDinamicNotification() {
      this.$emit('updateFormData', {
        notifications: this.situationDinamicSelected.notification,
      });
    },
    addDinamicNotification(selectedNotification) {
      if (selectedNotification.name === 'Lembrete') {
        selectedNotification.notification.push({
          name: 'notificação',
          key: `notification_${selectedNotification.notification.length + 1}`,
          position: selectedNotification.notification.length + 1,
          placeholder: 'Dias antes da data de vencimento',
          value: null,
        });
      }
      if (selectedNotification.name === 'Cobrança') {
        selectedNotification.notification.push({
          name: 'notificação',
          key: `notification_${selectedNotification.notification.length +
            1 +
            100}`,
          position: selectedNotification.notification.length + 1 + 100,
          placeholder: 'Dias após da data de vencimento',
          value: null,
        });
      }
    },
    removeDinamicNotification(selectedNotification) {
      selectedNotification.notification.pop();
    },
    updateShippingSchedule() {
      this.$emit('updateFormData', {
        shipping_schedule: this.shippingSchedule,
      });
    },
    updateWeekendShippingLock() {
      this.weekendShippingLock = !this.weekendShippingLock;
      this.$emit('updateFormData', {
        weekend_shipping_lock: this.weekendShippingLock,
      });
    },
  },

  computed: {
    ...mapGetters({
      userData: 'getUserData',
      tags: 'getTags',
      categories: 'getCategories',
      userMessages: 'getUserMessages',
    }),
  },
  props: {
    placeholderUuid: {
      type: String,
    },
  },
};
</script>

<style scoped>
.card-wise-wise {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px auto;
}
.card-header-wise {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}
.card-header-wise span {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}
.form-group {
  margin-bottom: 15px;
}
.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.form-control-time {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.shipping-time {
  display: flex;
  gap: 20px;
  width: 100%;
}
.form-input-control {
  width: 100%;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.form-input-control input {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 8px;
}
.btn {
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
  cursor: pointer;
  border: transparent;
}
.btn-info {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}
.btn-info:hover {
  background-color: #08e3ff;
  border-color: #08e3ff;
}
.btn-info:active {
  background-color: #008697;
  border-color: #008697;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}
.btn-info:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #08e3ff;
}
.btn-info.disabled {
  background-color: rgba(0, 188, 212, 0.5);
  border-color: rgba(0, 188, 212, 0.5);
}
.btn-danger {
  background-color: #ff5370;
  border-color: #ff5370;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-danger:hover {
  background-color: #ff869a;
  border-color: #ff869a;
}

.btn-danger:active {
  background-color: #ff163d;
  border-color: #ff163d;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-danger:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #ff869a;
}

.btn-danger.disabled {
  background-color: rgba(255, 83, 112, 0.5);
  border-color: rgba(255, 83, 112, 0.5);
}
</style>
